import { Injectable } from '@angular/core';
//import { HttpClient } from 'selenium-webdriver/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ProductGroup } from './productgroup';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');


@Injectable({
  providedIn: 'root'
})
export class ProductgroupService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) { }

  Get(): Observable<ProductGroup[]> {
    return this.httpClient.get<ProductGroup[]>(this.baseUrl + 'api/ProductGroupApi/GetAll')
  }

  Post(productgroup: ProductGroup): Observable<any> {


    return this.httpClient.post(this.baseUrl + 'api/ProductGroupApi/Add', productgroup, { headers: header, observe: 'response' })
  }
  Delete(productgroup: ProductGroup) {

    return this.httpClient.post(this.baseUrl + 'api/ProductGroupApi/activeordeactive', productgroup, { headers: header, observe: 'response' })
  }
  Put(ProductGroup: ProductGroup): Observable<any> {

    return this.httpClient.put(this.baseUrl + 'api/ProductGroupApi/Update', ProductGroup, { headers: header, observe: 'response' })
  }

}
